import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Timeline } from './Timeline';
export function TimelinePage() {
  return <>
      <Helmet data-id="element-324">
        <title data-id="element-325">Timeline - Early Warning Report</title>
        <meta name="description" content="2026 Round New gTLD Application Submission and Early Warning Timeline" data-id="element-326" />
      </Helmet>
      <section className="w-full bg-white text-secondary-800 text-base leading-7 font-sans rounded-xl shadow-2xl overflow-hidden" data-id="element-327">
        <div className="bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 text-white py-16 px-8 relative overflow-hidden" data-id="element-328">
          <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-329"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent" data-id="element-330"></div>
          <div className="relative z-10" data-id="element-331">
            <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-center leading-tight" data-id="element-332">
              Application Timeline
            </h1>
            <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-333">
              2026 Round New gTLD Application Submission and Early Warning
              Timeline
            </p>
          </div>
        </div>
        <div className="px-8 py-12" data-id="element-334">
          <Timeline data-id="element-335" />
        </div>
      </section>
    </>;
}